"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyAssignmentSchema () {
        return CompetencyAssignmentSchema;
    },
    get CompetencyAssignmentSourceSchema () {
        return CompetencyAssignmentSourceSchema;
    },
    get CompetencyAssignmentStatusSchema () {
        return CompetencyAssignmentStatusSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _constants = require("./constants");
const CompetencyAssignmentSourceSchema = _zod.z.enum([
    "role",
    "company_wide"
]);
const CompetencyAssignmentStatusSchema = _zod.z.enum([
    "active",
    "archived"
]).default("active");
const CompetencyAssignmentSchema = _base.BaseDocument.extend({
    competency_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    source: CompetencyAssignmentSourceSchema,
    role_id: _zod.z.instanceof(_bson.ObjectId).nullable().default(null),
    expected_level: _zod.z.number().int().min(1).max(_constants.MAX_COMPETENCY_LEVELS).nullable().default(null),
    current_level: _zod.z.number().int().min(1).max(_constants.MAX_COMPETENCY_LEVELS).nullable().default(null),
    status: CompetencyAssignmentStatusSchema,
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
